// Official certification marks, keyed by the certification name used in
// i18n/<lang>/common.js. Sources:
//   pure-ceylon-cinnamon: Export Development Board (srilankabusiness.com)
//   eu-pgi: EU PGI symbol as published by the EDB for Ceylon Cinnamon
//   hac-halal: Halal Assessment Council Sri Lanka, "Type 2" logo (required for exports)
// Certifications without an entry here are shown as text badges.
import pureCeylonCinnamon from './pure-ceylon-cinnamon.webp';
import euPgi from './eu-pgi.webp';
import hacHalal from './hac-halal.webp';

const certificationLogos = {
  'Pure Ceylon Cinnamon': pureCeylonCinnamon,
  'Ceylon Cinnamon PGI': euPgi,
  Halal: hacHalal,
};

export default certificationLogos;
